export default "__VITE_ASSET__D3sFK3cJ__"